module.exports = __webpack_public_path__ + "static/media/rectangle-12@3x.bb910391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/rectangle-12@3x.png
// module id = 77
// module chunks = 19